import { Pipe, PipeTransform } from '@angular/core';
import { ProjectStakingTypeSchema } from '@vmspdb/definitions';
import { AbstractEnumPipe } from './abstract-enum.pipe';

@Pipe({
  name: 'enumProjectStakingType',
  standalone: false,
})
export class EnumProjectStakingTypePipe
  extends AbstractEnumPipe
  implements PipeTransform
{
  readonly enum = ProjectStakingTypeSchema;
}
